module.exports = new __parcel__URL__("machine_info_upgrade_button.1330e988.png").toString();